import React from 'react'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';

const CustomDialog = ({children, open, onClose, extraStyle = {}, width = 400, isMobile, padding = 4}) => {
      
    const theme = sessionStorage.getItem("smartReportTheme");

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width : isMobile ? 320 : width,
        bgcolor: theme === "dark" ? '#0D1B2A' : 'background.paper',
        border: `1px solid ${theme === "dark" ? '#ccc' : '#000'}`,
        boxShadow: 24,
        p: padding,
        ...extraStyle
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                {children}
            </Box>
        </Modal>
    )
}

export default CustomDialog;
